import React, { useMemo } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./PaintingGallery.css";
import { ImageHelper, GalleryImage } from "./ImageHelper";
import { Painting } from "./painting";

interface PaintingGalleryProps {
  paintings: Painting[];
}

function PaintingGallery(props: PaintingGalleryProps) {
  const galleryImages: GalleryImage[] = useMemo(() => {
    const images: GalleryImage[] = [];
    for (const item of props.paintings) {
      images.push(ImageHelper.createGalleryImage(item));
    }
    return images;
  }, [props.paintings]);

  return (
    <ImageGallery
      items={galleryImages}
      slideDuration={800}
      slideInterval={4000}
      thumbnailPosition={"bottom"}
    />
  );
}

export default PaintingGallery;
